import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { PHASE } from './constants';
import { shallowRef } from 'vue';
import requirement012 from '../../../../components/vue/individualWorkSupport/Requirement012.vue';


/**
 * 書込みAPI関数
 */
export async function writeApi(self) {
  try {
    self.isLoading = true;

    const pinVerifiedRes = await individualWorkSupportUtil.postVerifyPinNumber(
      self,
      String(self.workSupportId).substring(0, 2),
      self.systemId,
      {
        pin_number: self.fixedPinNumber
      },
    );

    if (!pinVerifiedRes || !pinVerifiedRes.data.verified) {
      self.phase = PHASE.ERROR_PIN_NUMBER;
      return;
    }

    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      // POSTリクエストbody
      {
        id_token: token.id_token,
        type: 'write'
      },
      // エラー発生のコールバックを実装する。
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (response) {
      // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
      // エラーコールバックが呼ばれた場合は、null になる。
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 正常終了：メータ交換確認画面に遷移
          // WS12機能を実行
          self.currentWizard = shallowRef(requirement012);
          self.modal_requirement_038 = false;
          break;
        case REQUEST_STATUS_FAILED:
          // 異常終了：共通エラー画面に遷移
          self.showUnexpectedError();
          break;
        default:
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}